import {
  buttonClasses,
  dialogActionsClasses,
  dialogContentClasses,
  dialogTitleClasses,
  type Components,
} from '@mui/material';
import { dialogLabelClasses } from '../../components/Dialog/DialogLabel';
import { themeVars } from '../themeVars';
import { typographyStyles, type Theme } from './utils';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`.${dialogLabelClasses.root} + .${dialogTitleClasses.root}`]: {
        paddingTop: 0,
      },
      [`* + .${dialogActionsClasses.root}`]: {
        // Not on DialogActions itself to avoid margins on standalone elements
        marginTop: theme.spacing(5),
      },
      [`.${dialogContentClasses.root}:last-of-type`]: {
        paddingBottom: theme.spacing(3),
      },
    }),
    paper: ({ theme }) => ({
      background: themeVars(theme).palette.background.default,
      borderRadius: theme.shape.borderRadius,
      boxShadow: 'none',
      ...theme.applyStyles('dark', {
        border: `1px solid ${themeVars(theme).palette.border.subtle}`,
      }),
    }),
  },
};

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...typographyStyles(theme.typography.h5),
      padding: theme.spacing(3, 3, 1.5),
    }),
  },
};

export const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: 0,
      padding: theme.spacing(0, 3),
    }),
  },
};

export const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'flex-end',

      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',

        // On mobile, stretch buttons to fill the available space
        [`.${buttonClasses.root}`]: {
          flex: 1,
        },
      },
    }),
  },

  variants: [
    {
      props: (props) => !props.disableSpacing,
      style: ({ theme }) => ({
        paddingBottom: theme.spacing(3),
        paddingInline: theme.spacing(3),
        '& > :not(style) ~ :not(style)': {
          marginLeft: 'unset',
        },
      }),
    },
  ],
};
